module.exports = __webpack_public_path__ + "static/media/JetMinds6.fe044bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/JetMinds6.png
// module id = 788
// module chunks = 20